
import Vue from 'vue';
import {HTTPCODES} from '../../plugins/types';
/**
 * @module Store/loadbalancer
 * @description Module for file handling
 */

/**
 * @constant State of files store
 * @type {object}
 * @description This constant holds the state of files store
 * */
const state = {
    authUrl: `${process.env.VUE_APP_AUTH_LOCATION}`,
    redirections: []
};

/**
 * @constant Getters
 * @type {object}
 * @description This constant represents the getters for the files store
 * */
const getters = {
    getRedirections: state => state.redirections
};

/**
 * @constant Mutations
 * @type {object}
 * @description This constant represents the mutations for the files store
 * */
const mutations = {
    setRedirections: (state, redirections) => state.redirections = redirections,
    setRedirectionsSingle: (state, redirection) => state.redirections.push(redirection),
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async setRedirectionAsync ({state, commit}, payload) {
        try {
            let {data} = await Vue.axios.post(`${state.authUrl}/redirection`,
                {
                    ...payload
                },
                {
                    headers: {
                        'x-godlike': "GUqIE78609NzNkLFA44X065gQH80mOBk",
                    }
                });
            commit('setRedirectionsSingle', data)
            return {data};
        } catch (err) {
            if(err.response) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'to create redirection'
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to create redirection`
            });
    }},
    async deleteRedirectionAsync ({state, commit, dispatch}, payload) {
        try {
            let {data} = await Vue.axios.delete(`${state.authUrl}/redirection/${payload.context}`,
                {
                    headers: {
                        'x-godlike': "GUqIE78609NzNkLFA44X065gQH80mOBk",
                    }
                });
            dispatch('getRedirectionsAsync')
            return {data};
        } catch (err) {
            if(err.response) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'to remove redirection'
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to remove redirection`
            });
    }},

    async getRedirectionsAsync ({state, commit}) {
        try {
            let {data} = await Vue.axios.get(`${state.authUrl}/redirection`,
                {
                    headers: {
                        'x-godlike': "GUqIE78609NzNkLFA44X065gQH80mOBk",
                        "Access-Control-Allow-Origin": "*"
                    }
                });
                commit('setRedirections', data)
            return {data};
        } catch (err) {
            if(err.response) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'to get redirections'
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to get redirections`
            });
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
